import styled from 'styled-components';
import { Card } from '@veneer/core';
import { primitives } from '@veneer/primitives';
const { color, typography } = primitives;

export const Container = styled.div`
  padding: 40px;
  max-width: 526px;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;

  @media (max-width: 768px) {
    padding: 32px 24px 32px 24px;
    gap: 32px;
  }
`;

export const MainContent = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 32px;
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const SurveySection = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SurveySectionWrapper = styled(Card)`
  && {
    padding: 8px 16px;
    height: 50px;
    max-width: 494px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 768px) {
      width: unset;
    }
  }
`;

export const NotificationItem = styled.div`
  width: 100%;
`;

export const SurveyText = styled.div`
  font-size: ${typography.size2};
  font-weight: ${typography.weight3};
  line-height: ${typography.lineHeight3};
`;

export const HeaderContainer = styled.div`
  width: 100%;
`;

export const MainTitle = styled.h1`
  font-family: ${typography.family0};
  color: ${color.black};
  font-size: ${typography.size8};
  line-height: ${typography.lineHeight8};
  font-weight: ${typography.weight4};
  @media (max-width: 768px) {
    font-size: ${typography.size5};
    line-height: ${typography.lineHeight5};
    font-weight: ${typography.weight4};
  }
`;
